import React from 'react';
import { getGridPosition, getGridContainerStyle } from './grid-options';
import styles from './grid.scss';
export const Grid = _ref => {
  let {
    items,
    layout,
    isRTL
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    dir: isRTL ? 'rtl' : '',
    style: getGridContainerStyle(layout),
    className: styles.container
  }, items.map(item => {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.elementContainer,
      key: "form-field-container-" + item.id,
      style: getGridPosition(item.layout)
    }, item.component);
  }));
};
//# sourceMappingURL=grid.js.map